import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BillingStatus } from './OrganizationBillingLayout';
import {
  formatBillingCycleRange,
  formatBillingDate
} from 'util/organizationBillingFormat';

const BillingCycleSummary = ({ profile }) => {
  const hasCycle = Boolean(profile?.CycleStartUtc && profile?.CycleEndUtc);
  const needsPaymentSetup =
    profile?.BillingSetupRequired ??
    (!hasCycle &&
      profile?.Status === 'Inactive' &&
      !profile?.DefaultPaymentMethod);

  return (
    <section
      aria-label="Current billing cycle"
      className="border rounded-3 bg-soft-primary p-3 mb-3"
    >
      <Row className="g-3 align-items-center">
        <Col xs={12} md>
          <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
            <span className="text-600 fs--1 fw-semi-bold">
              Current billing cycle
            </span>
            <BillingStatus>{profile?.Status}</BillingStatus>
          </div>
          <h5 className="text-900 mb-1">
            {formatBillingCycleRange(
              profile?.CycleStartUtc,
              profile?.CycleEndUtc
            )}
          </h5>
          <p className="text-600 fs--1 mb-0">
            {needsPaymentSetup ? (
              <>
                Add a payment method and set it as default to view and review
                shared journals. Notaries can share journals before setup. Your
                first monthly billing cycle starts when setup is complete. Go to{' '}
                <Link to="/organization/billing/payment-methods">
                  Payment Methods
                </Link>{' '}
                to complete billing setup.
              </>
            ) : hasCycle ? (
              'Monthly billing period for hosted accounts'
            ) : (
              'Your billing dates will appear when the cycle starts.'
            )}
          </p>
        </Col>
        {hasCycle && (
          <Col xs={12} md="auto">
            <Card body className="shadow-none border px-3 py-2">
              <div className="text-600 fs--1 mb-1">
                Next hosted billing date
              </div>
              <time dateTime={profile.CycleEndUtc} className="d-block">
                <span className="d-block text-900 fw-semi-bold">
                  {formatBillingDate(profile.CycleEndUtc, 'MMM D, YYYY')}
                </span>
                <span className="d-block text-600 fs--1 mt-1">
                  {formatBillingDate(profile.CycleEndUtc, 'h:mm A')}
                </span>
              </time>
            </Card>
          </Col>
        )}
      </Row>
    </section>
  );
};

BillingCycleSummary.propTypes = {
  profile: PropTypes.shape({
    Status: PropTypes.string,
    DefaultPaymentMethod: PropTypes.object,
    BillingSetupRequired: PropTypes.bool,
    CycleStartUtc: PropTypes.string,
    CycleEndUtc: PropTypes.string
  })
};

export default BillingCycleSummary;
